import { AnimatePresence } from 'framer-motion';
import { useRef } from 'react';
import animations from '../../helpers/animations';
import {
    BackgroundModal,
    ModalContent,
    ModalWrapper,
} from './styles';

import { FaCircleCheck } from 'react-icons/fa6';
import { redirectYourTickets } from '../../helpers/utils';
import { usePaymentModalStore } from '../../store/payment/paymentModalStore';
import { BigButton } from '../../components/BigButton';
import { useToken } from '../../store/auth/tokenStore';

export function ModalPaymentFinished() {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const paymentModal = usePaymentModalStore();
    const { token } = useToken();

    if (paymentModal.method !== 'finished') return;

    return (
        <AnimatePresence>
            {paymentModal.isVisible && (
                <BackgroundModal
                    ref={modalRef}
                    {...animations.fadeInOut(0.1)}
                >
                    <ModalWrapper onClick={e => e.stopPropagation()}>
                        <ModalContent>
                            <FaCircleCheck
                                className='icon-circle-check'
                                color='#22C55E'
                            />
                            <div>
                                <h3>Transação concluída com sucesso!</h3>
                                <p>A compra é sua, mas a satisfação de te ver feliz é toda nossa! Obrigada pela confiança!</p>
                                <BigButton
                                    bgColor='primary'
                                    color='primary'
                                    onClick={() => redirectYourTickets(token ?? undefined)}
                                    allWidth={true}
                                >
                                    Visualizar tickets
                                </BigButton>
                                <a href="/">Voltar para loja</a>
                            </div>
                        </ModalContent>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>
    );
}
